import { useState, useCallback } from 'react';
import { MemoryKV } from './memory.types';

export const useMemory = () => {
  const [memoryKv, setMemoryKv] = useState<MemoryKV>({});
  const [latestProfileEntry, setLatestProfileEntry] = useState<MemoryKV | null>(null);

  const handleNoteMade = useCallback((newEntry: MemoryKV) => {
    setLatestProfileEntry(newEntry);
    setMemoryKv((prev) => {
      const updatedMemory = { ...prev };
      const [key, value] = Object.entries(newEntry)[0];

      // Append to existing keys for job preferences, otherwise overwrite
      if (key === "Interested Jobs" || key === "Not Interested Jobs") {
        if (updatedMemory[key]) {
          updatedMemory[key] = `${updatedMemory[key]}\n\n${value}`;
        } else {
          updatedMemory[key] = value;
        }
      } else {
        updatedMemory[key] = value;
      }
      return updatedMemory;
    });
  }, []);

  const clearMemory = useCallback(() => {
    setMemoryKv({});
    setLatestProfileEntry(null);
  }, []);

  return {
    memoryKv,
    latestProfileEntry,
    handleNoteMade,
    clearMemory,
  };
};
